/* eslint-disable indent */
import * as types from '@/store/mutation-types'

export default {
    [types.SET_APP_DETAILS](state, payload) {
        state.details = payload
        state.url = payload.api_url
        state.apiToken = payload.api_headers['api-token']
    }
}
